module.exports = __webpack_public_path__ + "img/clock.8f11b300.svg";